import { useState } from 'react';

export const useSearcher = ({ options, onSelect, defaultValue }) => {
  const [selected, setSelected] = useState(defaultValue);
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(!open);

  const handleSelect = (option) => {
    if (onSelect) onSelect(option);
    setSelected(option);
    handleOpen();
  };

  const handleInput = ({ target: { value } }) => {
    setFilteredOptions(options.filter(({ label }) => label.toUpperCase().includes(value.toUpperCase())));
  };

  const deleteSelected = () => setSelected('');

  return {
    handleInput,
    selected,
    handleSelect,
    open,
    filteredOptions,
    handleOpen,
    deleteSelected
  };
};
